export default "__VITE_ASSET__CBpPpHjH__"